"use client";

import dynamic from "next/dynamic";
import type { LpFooterConfigData } from "@lib/lpFooterConfig";

/**
 * hen-ui ships as a single `"use client"` module that statically imports
 * recharts, d3, embla and the Lucide icon map, so a static import puts all of
 * it in the initial payload of every program page — including the ones with no
 * footer_config. Loading it client-side keeps the cost proportional to
 * adoption: pages that render no LpFooter never fetch the chunk.
 */
const LpFooter = dynamic(() => import("@components/LpFooter").then((mod) => ({ default: mod.LpFooter })), {
  ssr: false,
});

export const LpFooterLazy = ({ config }: { config: LpFooterConfigData }) => <LpFooter config={config} />;
